var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "contentBox",
    { attrs: { mainId: "auth", loading: _vm.loading, noMt: true } },
    [
      _c("contentTitle", {
        attrs: {
          label: _vm.getLabel(),
          labelClass: "text-white",
          close: _vm.routeBack,
          noScroll: true
        }
      }),
      _vm._v(" "),
      _c("contentActions", [
        _c(
          "button",
          {
            staticClass: "btn btn-outline-light btn-sm",
            class: { active: _vm.tabActive == "login" },
            on: {
              click: function($event) {
                return _vm.showTab("login")
              }
            }
          },
          [_vm._v("\n\t\t\tLogin\n\t\t")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-outline-light btn-sm",
            class: { active: _vm.tabActive == "signUp" },
            on: {
              click: function($event) {
                return _vm.showTab("signUp")
              }
            }
          },
          [_vm._v("\n\t\t\tSign Up\n\t\t")]
        )
      ]),
      _vm._v(" "),
      _c("contentBody", [
        _vm.tabActive == "login"
          ? _c("div", { staticClass: "p-3" }, [
              _c(
                "form",
                {
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.login.apply(null, arguments)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      { staticClass: "mb-1", attrs: { for: "loginEmail" } },
                      [_vm._v("Email")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.email,
                          expression: "email"
                        }
                      ],
                      staticClass: "form-control",
                      class: { "is-invalid": _vm.error && _vm.error.email },
                      attrs: {
                        type: "email",
                        id: "loginEmail",
                        "aria-describedby": "emailHelp",
                        placeholder: "Enter email"
                      },
                      domProps: { value: _vm.email },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.email = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "invalid-feedback" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(_vm.error && _vm.error.email) +
                          "\n\t\t\t        "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      { staticClass: "mb-1", attrs: { for: "loginPassword" } },
                      [_vm._v("Password")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.password,
                          expression: "password"
                        }
                      ],
                      staticClass: "form-control",
                      class: { "is-invalid": _vm.error && _vm.error.password },
                      attrs: {
                        type: "password",
                        id: "loginPassword",
                        placeholder: "Password"
                      },
                      domProps: { value: _vm.password },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.password = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "invalid-feedback" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(_vm.error && _vm.error.password) +
                          "\n\t\t\t        "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "small",
                      {
                        staticClass: "form-text text-muted",
                        attrs: { id: "passwordHelp" }
                      },
                      [
                        _vm._v("Forget your password? "),
                        _c("a", { attrs: { href: "/users/forgot-password" } }, [
                          _vm._v("Recover it")
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-lg btn-dark btn-block",
                      attrs: { type: "submit" }
                    },
                    [_vm._v("Login")]
                  )
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.tabActive == "signUp"
          ? _c("div", { staticClass: "p-3" }, [
              _c(
                "form",
                {
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.signUp.apply(null, arguments)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      { staticClass: "mb-1", attrs: { for: "signUpEmail" } },
                      [_vm._v("Email")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.email,
                          expression: "email"
                        }
                      ],
                      staticClass: "form-control",
                      class: { "is-invalid": _vm.error && _vm.error.email },
                      attrs: {
                        type: "email",
                        id: "signUpEmail",
                        "aria-describedby": "emailHelp",
                        placeholder: "Enter email"
                      },
                      domProps: { value: _vm.email },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.email = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "invalid-feedback" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(_vm.error && _vm.error.email) +
                          "\n\t\t\t        "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "small",
                      {
                        staticClass: "form-text text-muted",
                        attrs: { id: "emailHelp" }
                      },
                      [_vm._v("We'll never share your email with anyone else.")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      { staticClass: "mb-1", attrs: { for: "signUpPassword" } },
                      [_vm._v("Password")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.password,
                          expression: "password"
                        }
                      ],
                      staticClass: "form-control",
                      class: { "is-invalid": _vm.error && _vm.error.password },
                      attrs: {
                        type: "password",
                        id: "signUpPassword",
                        placeholder: "Password"
                      },
                      domProps: { value: _vm.password },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.password = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "invalid-feedback" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(_vm.error && _vm.error.password) +
                          "\n\t\t\t        "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "small",
                      {
                        staticClass: "form-text text-muted",
                        attrs: { id: "emailHelp" }
                      },
                      [_vm._v("Minimum 4 characters.")]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-lg btn-dark btn-block",
                      attrs: { type: "submit" }
                    },
                    [_vm._v("Sign Up")]
                  )
                ]
              )
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a916e3b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a916e3b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/index.vue
// module id = null
// module chunks = 